var ButtonMessage = require("app/ui/ButtonMessage"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    icons         = require("app/theme/icons"),
    kind          = require("enyo/kind");

module.exports = kind(/** @lends  app.MediaDetailPopup.OopsView.prototype */ {

    /**
     * @private
     */
    name: "app.MediaDetailPopup.OopsView",

    /**
     * @private
     */
    kind: ButtonMessage,

    /**
     * @private
     */
    fit: false,

    /**
     * @private
     */
    classes: "app-media-detail-popup-oops-view",

    /**
     * @private
     */
    handlers: {
        onMessageButtonTap: "onMessageButtonTap"
    },

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.$.button.set("theme", "neutral");

            // Usage of icon from OopsPage is on purpose
            this.$.button.set("icon", icons["app.OopsPage.PageView.button"]);
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService;

        // Usage of translations from OopsPage is on purpose
        this.$.title.set("content", i18nService.getString("app.OopsPage.Message.title"));
        this.$.body.set("content", i18nService.getString("app.OopsPage.Message.body"));
        this.$.button.set("caption", i18nService.getString("app.OopsPage.Message.Button.caption"));
        this.$.button.set("tooltip", i18nService.getString("app.OopsPage.Message.Button.tooltip"));
    },

    /**
     * Go back to previous history state, that's the best we can do for now.
     *
     * @private
     */
    onMessageButtonTap: function() {
        this.app.$.router.back();
    }

});
